export default "__VITE_ASSET__be03f273__"